import React from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";

import { getScreenNav, getScreen } from 'actions/screens';
import { Login, Appointment, Schedule, Clients, Employees, Client, Report, Expenses, Price, Settings, Employee, Egisz, Tasks } from 'pages';
import NotifyPopup from "components/NotifyPopup";

import _helper from "actions/helper";

import './styles/index.less';
import './styles/themes/default.less';


class App extends React.Component {
    constructor(props) {
        super(props);

        const isLoginPage = window.location.pathname.indexOf("login") > -1;

        this.state = {
            loggedIn: isLoginPage ? false : !!localStorage.token
        };

        _helper.setupOnStart();
    }

    setLoginState(loggedIn) {
        this.setState({ loggedIn });
    }

    render() {
        globalThis.appView = this;

        const { loggedIn } = this.state;

        return (
            <>
                <div ref={el => globalThis.appBody = el} className="root flex1 flex">
                    <Router>
                        <Routes>
                            <Route path="/" element={getScreenNav(loggedIn, 'appointment', 'login')} />
                            <Route path="/login" element={getScreen(!loggedIn, <Login />, 'appointment')} />
                            <Route path="/appointment" element={getScreen(loggedIn, <Appointment />)} />
                            <Route path="/tasks" element={getScreen(loggedIn, <Tasks />)} />
                            <Route path="/schedule" element={getScreen(loggedIn, <Schedule />)} />
                            <Route path="/clients" element={getScreen(loggedIn, <Clients />)} />
                            <Route path="/report" element={getScreen(loggedIn, <Report />)} />
                            <Route path="/price" element={getScreen(loggedIn, <Price />)} />
                            <Route path="/expenses" element={getScreen(loggedIn, <Expenses />)} />
                            <Route path="/employees" element={getScreen(loggedIn, <Employees />)} />
                            <Route path="/employee" element={getScreen(loggedIn, <Employee />)} />
                            <Route path="/client" element={getScreen(loggedIn, <Client />)} />
                            <Route path="/egisz" element={getScreen(loggedIn, <Egisz />)} />
                            <Route path="/settings" element={getScreen(loggedIn, <Settings />)} />
                            <Route path="*" element={getScreenNav(true, 'appointment')} />
                        </Routes>
                    </Router>
                </div>
                <NotifyPopup ref={el => globalThis.appNotifyPopup = el} />
                <div ref={el => globalThis.appImageBox = el} className="overlayBox imageBox pos fixed sideAll flex centerAll"></div>
                <div ref={el => globalThis.appTooltip = el} className="tooltipItem pos fixed pad8 rad4 text p2"></div>
                <div ref={el => globalThis.appLoading = el} className="loading pos fixed sideAll flex centerAll"></div>
                <div ref={el => globalThis.appPrint = el} className="overlayBox printBox pos fixed sideAll flex centerAll">
                    <div className="inner flex"></div>
                    <div className="closeImg hand"></div>
                </div>
            </>
        );
    }
}

export default App;
